import "./login.css";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import NavBar from "../common/navBar/navBar";
import Footer from "../common/footer/footer";
import { logIn } from "../common/api/authUser";
import { toast } from "react-toastify";
import ACTIONS from "../../utils/constant/stringConstant";
import { useContext } from "react";
import { AppContext } from "../../contextApi/context";

function LogIn() {
  const [showpassword, setShowPassword] = useState(false);
  const togglepasswordVisibility = () => {
    setShowPassword(!showpassword);
  };
  const { dispatch } = useContext(AppContext);
  const navigate = useNavigate();
  const logInUser = async (form_data) => {
    const res = await logIn(form_data);
    if (res && res.data.responseCode === 200) {
      toast.success(res.data.resMessage);
      dispatch({ type: ACTIONS.LOG_IN, payload: res.data.data });
      setTimeout(() => {
        navigate(`/userpage/${res.data.data.id}`);
      }, 3000);
    } else if (res && res.data.responseCode === 400) {
      toast.error(res.data.errMessage);
    } else {
      toast.error("Something went wrong...");
    }
    return res;
  };
  const formik = useFormik({
    initialValues: {
      username_email: "",
      password: "",
    },
    validate: (values) => {
      const errors = {};
      if (!values.username_email) {
        errors.username_email = "Input username or email";
      } else if (values.username_email.length < 3) {
        errors.username_email = "Must be at least 3 characters";
      }
      if (!values.password) {
        errors.password = "Input password";
      } else if (values.password.length < 6) {
        errors.password = "Must be at least 6 characters";
      }
      return errors;
    },
    onSubmit: async function (values, action) {
      console.log("Form submitted:", values);
      await logInUser(values);
      action.resetForm();
    },
  });

  return (
    <>
      <NavBar />
      <div className="container  login-page position-relative z-0">
        <div className="left text-center mt-5">
          <div className="pt-5">
            <h6 className="fs-1 fw-bold mt-5 mb-5">Welcome back, Developer!</h6>
            <p className="fs-4">We’re excited to see you again! </p>
            <div className="me-5 ms-5">
              <p className="me-5 ms-5 text-muted mt-3">
                "Let’s continue building the future of tech together—log in to
                share your latest discoveries and explore new ideas. Ready to
                dive into your next coding adventure? Log in to keep sharing
                your insights, learn from fellow developers, and contribute to
                the <span className="text-warning fs-5">DevDiaries</span>{" "}
                community. Your next big breakthrough is just a login away, so
                share your programming tips, tricks, and experiences with the
                community!"
              </p>
            </div>
          </div>
        </div>

        <div className="login">
          <form onSubmit={formik.handleSubmit}>
            <h1 className="text-center mb-5" style={{ color: "#1E4682" }}>
              Login
            </h1>
            <div className="mb-3">
              <label htmlFor="username_email" className="form-label">
                Email address or User Name
              </label>
              <div>
                <input
                  type="text"
                  className={
                    formik.touched.username_email &&
                    formik.errors.username_email
                      ? "border border-danger login_input  d-block w-100 p-2"
                      : "border login_input  d-block w-100 p-2"
                  }
                  id="username_email"
                  placeholder="Enter your email or username"
                  name="username_email"
                  value={formik.values.username_email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.username_email &&
                formik.errors.username_email ? (
                  <p className="form-error mt-0">
                    {formik.errors.username_email}
                  </p>
                ) : null}
              </div>
            </div>
            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <div className=" position-relative">
                <input
                  type={showpassword ? "text" : "password"}
                  className={
                    formik.touched.password && formik.errors.password
                      ? "border border-danger login_input w-100 p-2 d-flex mb-0"
                      : "border login_input w-100 p-2 d-flex mb-0"
                  }
                  id="password"
                  placeholder="Enter your password"
                  name="password"
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <FontAwesomeIcon
                  icon={showpassword ? faEyeSlash : faEye}
                  className="eye-position"
                  onClick={togglepasswordVisibility}
                />
              </div>
              {formik.touched.password && formik.errors.password ? (
                <p className="form-error mt-2">{formik.errors.password}</p>
              ) : null}
            </div>
            <div className="mb-3 form-check">
              <div>
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="exampleCheck1"
                />
                <label className="form-check-label" htmlFor="exampleCheck1">
                  Remember me?
                </label>{" "}
                <Link to="/forgotpassword" style={{ textDecoration: "none" }}>
                  Forgot password
                </Link>
              </div>
            </div>
            <button type="submit" className="btn btn-submit">
              Login
            </button>
            <div className="para">
              <p>
                Don't have an account?{" "}
                <Link to="/register" style={{ textDecoration: "none" }}>
                  Register here
                </Link>
              </p>
            </div>
          </form>
        </div>
      </div>
      <footer>{<Footer />}</footer>
    </>
  );
}
export default LogIn;
